<div class="container-fluid pb-3 pt-2">
  <h4 class="mb-2">{{headingText}}</h4>
  <div *ngIf="!loading; else loader">
    <mat-accordion>
      <mat-expansion-panel expanded>
        <mat-expansion-panel-header>
          <mat-panel-title>
            Ricerca
          </mat-panel-title>
          <mat-panel-description>
            Ricerca avanzata compagnie
          </mat-panel-description>
        </mat-expansion-panel-header>
        <ricerca-generica-anagrafiche (search)="search = $event"></ricerca-generica-anagrafiche>
      </mat-expansion-panel>
    </mat-accordion>
    <resourceful-index #index [search]="search" [modelService]="compagniaService" [deleteFunction]="deleteFunction" [showReset]="showReset"
      [columnDefinitions]="columnDefinitions" [editFunction]="editFunction" [multipleSelection]="multipleSelection"
      [selectionMode]="selectionMode" (selectedModel)="closeDialogWithSelectedModel($event)" [relations]="relations">
    </resourceful-index>

    <button mat-raised-button color="primary" class="mt-4" (click)="add()">
      Aggiungi una compagnia<mat-icon>add</mat-icon>
    </button>

    <button *ngIf="multipleSelection" mat-raised-button color="primary" class="mt-4 ml-2" (click)="save()">
      Salva compagnie
    </button>

  </div>
  <ng-template #loader>
    <mat-spinner></mat-spinner>
  </ng-template>
</div>